<app-global-header
  [header]="header"
  [headerIcon]="featureHighlightIcon"
  [disableGlobalBanner]="true"
  [theme]="headerTheme$ | async"
  (onClickHeaderIcon)="showFeatureHighlightDialog()"
>
  <center-slot>
    <app-search
      *ngIf="enableSearch && !(isIaNavEnabled$ | async)"
      [searchQuery]="searchQueryValue"
      [placeholder]="searchPlaceholder"
      [trackingScreenName]="trackingScreenName"
      [trackingObject]="trackingObject"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (onSearchTermChange)="searchTerm($event)"
    >
    </app-search>
  </center-slot>

  <right-slot [ngSwitch]="!!primaryAction?.route">
    <i2g-router-link
      *ngSwitchCase="true"
      buttonStyle="emphasis"
      type="create-action"
      alignment="center"
      [label]="primaryAction.label"
      [route]="primaryAction.route"
      [disabled]="primaryAction.disabled"
      [e2eId]="primaryAction.e2eId"
      [trackingObject]="primaryAction.trackingObject"
      [trackingAction]="primaryAction.trackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (linkClick)="onPrimaryAction.emit()"
    >
    </i2g-router-link>

    <button
      *ngSwitchDefault
      i2gButton
      buttonStyle="emphasis"
      class="create-action"
      [disabled]="primaryAction.disabled"
      [attr.data-e2e-id]="primaryAction.e2eId"
      trackable
      [trackingObject]="primaryAction.trackingObject"
      [trackingAction]="primaryAction.trackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (click)="onPrimaryAction.emit()"
    >
      {{ primaryAction.label }}
    </button>
  </right-slot>
</app-global-header>

<div
  class="navigation-header"
  [class.ia-navigation-header]="isIaNavEnabled$ | async"
  [class.show-divider]="filters?.size > 0"
>
  <ng-container *ngIf="filters?.size > 0">
    <ul class="filters-list" *ngIf="!searchQuery">
      <li class="filter" *ngFor="let filter of filters">
        <i2g-router-link
          [label]="filter.label | translate"
          [route]="filter.route"
          [e2eId]="filter.e2eId"
          [trackingObject]="filter.trackingObject"
          [trackingAction]="filter.trackingAction"
          [trackingAdditionalProperties]="trackingAdditionalProperties"
          alignment="center"
        >
        </i2g-router-link>
      </li>
    </ul>
  </ng-container>

  <div class="navigation-header-right-slot">
    <ng-content select=".navigation-header-right"></ng-content>
  </div>
</div>

<app-global-banner></app-global-banner>

<app-feedback-card
  *ngIf="showFeedbackCard$ | async"
  class="feedback-card"
  [feedbackScreenName]="feedbackScreenName"
  [feedbackCard]="feedbackCardInfo"
  [accountId]="account?.accountId"
  [settings]="settings"
  [currentPlan]="currentPlan"
  [userEmail]="userEmail"
>
</app-feedback-card>

<div
  class="router-outlet-wrapper scroll-container"
  [ngClass]="{
    'bulk-action-visible': enableBulkActions && selectedEntityBodies?.size > 0
  }"
>
  <router-outlet></router-outlet>
</div>

<ng-container *ngIf="enableBulkActions">
  <div *ngIf="selectedEntityBodies?.size > 0" class="bulk-actions-container">
    <ng-container *ngFor="let bulkAction of bulkActions">
      <button
        type="button"
        class="bulk-action"
        (click)="showBulkActionConfirmDialog(bulkAction.dialogId)"
      >
        {{ bulkAction.label }}
      </button>

      <app-confirm-dialog
        [dialogId]="bulkAction.dialogId"
        [confirmTitle]="bulkAction.dialogTitle"
        [confirmPrompt]="bulkAction.dialogPrompt"
        [yesText]="bulkAction.dialogConfirmText"
        [trackingObject]="trackingObject"
        [trackingScreenName]="trackingScreenName"
        [primaryActionTapped]="bulkAction.dialogPrimaryActionTrackingAction"
        [primaryActionTrackingAdditionalProperties]="
          bulkTrackingAdditionalProperties
        "
        [trackingAdditionalProperties]="trackingAdditionalProperties"
        (onClose)="onBulkActionDialogClose(bulkAction.id, $event)"
      >
      </app-confirm-dialog>
    </ng-container>

    <button
      type="button"
      class="bulk-action delete-action"
      data-e2e-id="bulk-action-delete"
      (click)="showDeleteConfirmDialog()"
    >
      {{ 'ACTION.DELETE' | translate }}
    </button>

    <span class="selected-entities-text" [ngSwitch]="selectedEntityBodies.size">
      <ng-container *ngSwitchCase="1">
        {{
          bulkActionSingleTranslateKey
            | translate: { number: selectedEntityBodies.size }
        }}
      </ng-container>

      <ng-container *ngSwitchDefault>
        {{
          bulkActionPluralTranslateKey
            | translate: { number: selectedEntityBodies.size }
        }}
      </ng-container>
    </span>
  </div>

  <app-confirm-dialog
    [dialogId]="deleleConfirmDialogId"
    [confirmTitle]="bulkDeleteConfirmTitleKey | translate"
    [confirmPrompt]="bulkDeleteConfirmPromptKey | translate"
    [yesText]="'ACTION.DELETE' | translate"
    [isDeleteAction]="true"
    [trackingDialogName]="deleteConfirmTrackingDialogName"
    [trackingScreenName]="trackingScreenName"
    [primaryActionTapped]="bulkActionPrimaryTrackingAction"
    [primaryActionTrackingAdditionalProperties]="
      bulkTrackingAdditionalProperties
    "
    [secondaryActionTapped]="bulkActionSecondaryTrackingAction"
    [secondaryActionTrackingAdditionalProperties]="
      bulkTrackingAdditionalProperties
    "
    [trackingAdditionalProperties]="trackingAdditionalProperties"
    (onClose)="onDeleteConfirmClose($event)"
  >
  </app-confirm-dialog>
</ng-container>
